import { post } from "utils/apiClient";
import { v4 as uuidv4 } from 'uuid';

import React, { createContext, useState } from 'react'


const LocationMapImportContext = createContext()

function Provider({ children }) {
    const api_url = process.env.REACT_APP_API_URL

    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    const [importResponse, setImportResponse] = useState()


    const submitImport = async (data) => {
        
        setLoading(true)
        let response = null
        let totalSuccess = 0;
        let totalError = 0;
        let batchMessages = [];
        let downloadUrl
        try {
            const url = 'email/location/map/import'

            const total = data.data.length;
                const results = [];
                const jobId = uuidv4(); 
                for (let i = 0; i < total; i += 50) {
                    const batch = data.data.slice(i, i + 50);
                    try {
                    const response =await post(url, {'data': batch, 'job_id': jobId})
                    console.log(response)
                    const { message, successCount, errorCount } = response;
                    downloadUrl = response.downloadUrl
                    totalSuccess += successCount || 0;
                    totalError += errorCount || 0;
                    
                   
                    } catch (error) {
                        console.error(`Batch ${i / 50 + 1} failed`, error);
                    }
                }

            const finalResponse = {
                message: `All batches processed.`,
                successCount: totalSuccess,
                errorCount: totalError,
                downloadUrl: downloadUrl
            };
    
            console.log("Final Response:", finalResponse);
    
            setImportResponse(finalResponse);
            setLoading(false)
            setSuccess(true)
        } catch (error) {
            console.error(error)
            setLoading(false)
            setError(true)
        }
    }

    const valueToShare = {
        loading,
        setLoading,
        success,
        setSuccess,
        error,
        setError,
        submitImport,
        importResponse
    }

    return (
        <LocationMapImportContext.Provider value={valueToShare}>{children}</LocationMapImportContext.Provider>
    )

}


export { Provider }
export default LocationMapImportContext